import { jsx as d } from "react/jsx-runtime";
import { BREAKPOINTS as j } from "@fcamna/shared-component-foundations";
import { useRef as K, useState as N, useEffect as Q, useLayoutEffect as Y } from "react";
import { useTheme as _, styled as z } from "styled-components";
import { u as F } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as G, C as M } from "./useChartOptions-336145ca.mjs";
import { u as I } from "./useWindowDimensions-ae69e913.mjs";
const et = (x) => {
  const W = F({ label: "Heat Map Chart" }), { series: a, chartLibElement: y, xAxis: C, yAxis: l, legend: n, colorScaleRanges: s, hideLegendItems: i, height: h, width: m } = x, o = K(null), c = I().width, E = c < j.tabletMin, [$, b] = N(0), v = _(), { strapMarkerWidthAndHeight: A } = v.components.heatMapChart;
  Q(() => {
    const t = document.getElementById("heatmap-chart-wrapper"), r = t == null ? void 0 : t.clientWidth;
    r && b(r);
  }, []), Y(() => {
    var t, r;
    (r = (t = o == null ? void 0 : o.current) == null ? void 0 : t.chartRef) != null && r.current && (i == null || i.forEach((p) => {
      var f, w;
      const e = (w = (f = o == null ? void 0 : o.current) == null ? void 0 : f.chartRef) == null ? void 0 : w.current.querySelector(`div[seriesname="${p}"]`);
      e && (e == null || e.remove());
    }));
  }, [i]);
  const u = (t) => {
    let r = 0;
    return t.forEach(({ data: p }) => {
      const e = p.length;
      e > r && (r = e);
    }), r;
  }, H = a.length * 50, P = u(a) * 60 + (c - u(a) * 60) - 50, S = s == null ? void 0 : s.map(
    (t) => (t == null ? void 0 : t.name) === null ? { ...t, name: " " } : t
  ), T = y, { options: L, customStyles: D } = G({
    type: M.HEATMAP,
    xAxis: C,
    yAxis: l,
    colorScaleRanges: S,
    legend: { ...A, ...n }
  }), { legendStrapStyle: k, tooltipStyles: q, legendLeftRightPositionStyle: B } = D({
    type: M.HEATMAP
  }), O = [
    {
      breakpoint: 600,
      options: {
        chart: {
          width: "600px"
        }
      }
    }
  ], X = z.div`
    ${({ legend: t }) => {
    if (((t == null ? void 0 : t.indicatorShape) === "strap" || (t == null ? void 0 : t.indicatorShape) === void 0) && ((t == null ? void 0 : t.position) === "bottom" || (t == null ? void 0 : t.position) === "top"))
      return k;
  }};
    ${q};
    ${B};
    ${({ $maxWidth: t, ...r }) => t && t < 600 && `
      max-width: ${t}px;
      overflow-x: ${r.theme.components.heatMapChart.Wrapper.overflowX};`};

    ${({ $isMobile: t, ...r }) => t && `
      max-width: ${r.theme.components.heatMapChart.Wrapper.mobile.maxWidth};
      overflow-x: ${r.theme.components.heatMapChart.Wrapper.mobile.overflowX};`};
  `;
  return /* @__PURE__ */ d(
    X,
    {
      legend: n,
      "data-testid": "heatmap-wrapper",
      id: "heatmap-chart-wrapper",
      $isMobile: E,
      $maxWidth: $,
      ...W,
      children: /* @__PURE__ */ d(
        T,
        {
          series: a,
          options: { ...L, responsive: O },
          type: "heatmap",
          ref: o,
          height: h || H,
          width: m || P
        }
      )
    }
  );
};
export {
  et as HeatMapChart
};
